export default {
    cn: {
        closedTradesReport: {
            posText: '仓位类型：',
            timeText: '开仓时间：',
            ticketText: '交易单号：',
            groupText: '组别：',
            symbolText: '产品：',
            loginText: '账号：',
            ibNumText: '代理账号：',
            regionText: '地区编号：',
            securityText: '产品类型：',
            currencyText: '货币：',
            startTime: '开始时间',
            endTime: '结束时间',
            downloadName: '交易价值报表',
            openTime: '开仓时间',
            closedTime: '平仓时间',
            cmdMapping: { 0: '买入', 1: '卖出' },
            securityMapping: { 0: 'Forex', 1: 'CFD' },
            typeMapping: { "0": "未平仓", "1": "已平仓" },
            loadText: '正在下载,请稍候...',
            tableHead: [
                { key: 'TICKET', value: '单号' },
                { key: 'LOGIN', value: '账号' },
                { key: 'NAME', value: '姓名' },
                { key: 'GROUP', value: '组别' },
                { key: 'CURRENCY', value: '货币' },
                { key: 'IB_ID', value: '代理账号' },
                // { key: 'IB_NAME', value: '代理姓名' },
                { key: 'OID', value: '办事处号码' },
                { key: 'OFFICE_NAME', value: '所属办事处' },
                { key: 'RID', value: '地区编号' },
                { key: 'ACC_NAME', value: '所属地区' },
                { key: 'cmd', value: '交易类型' },
                { key: 'VOLUME', value: '手数' },
                { key: 'SYMBOL', value: '产品' },
                { key: 'security', value: '产品类型' },
                { key: 'SYMBOL_CONTRACT_SIZE', value: '合约大小' },
                { key: 'OPEN_TIME', value: '开仓时间' },
                { key: 'OPEN_PRICE', value: '开仓价' },
                { key: 'CLOSE_TIME', value: '平仓时间' },
                { key: 'CLOSE_PRICE', value: '平仓价' },
                { key: 'OPEN_VALUE', value: '开仓价值' },
                { key: 'CLOSE_VALUE', value: '平仓价值' },
                { key: 'TOTAL_VALUE', value: '交易单总价值' },
                { key: 'COMMISSION', value: '佣金' },
                { key: 'TAXES', value: '税金' },
                { key: 'COMMISSION_AGENT', value: '代理佣金' },
                { key: 'SWAPS', value: '利息' },
                { key: 'PROFIT', value: '盈亏' },
                { key: 'PIPES', value: '价位差' },
                { key: 'COMMENT', value: '注释' }
            ]
        }
    },
    hk: {
        closedTradesReport: {
            posText: '倉位類型：',
            timeText: '開倉時間：',
            ticketText: '交易單號：',
            groupText: '組別：',
            symbolText: '產品：',
            loginText: '賬號：',
            ibNumText: '代理賬號：',
            regionText: '地區編號：',
            securityText: '產品類型：',
            currencyText: '貨幣：',
            startTime: '開始時間',
            endTime: '結束時間',
            downloadName: '交易價值報表',
            openTime: '開倉時間',
            closedTime: '平倉時間',
            cmdMapping: { 0: '買入', 1: '賣出' },
            securityMapping: { 0: 'Forex', 1: 'CFD' },
            typeMapping: { "0": "未平倉", "1": "已平倉" },
            loadText: '正在下載,請稍候...',
            tableHead: [
                { key: 'TICKET', value: '單號' },
                { key: 'LOGIN', value: '賬號' },
                { key: 'NAME', value: '姓名' },
                { key: 'GROUP', value: '組別' },
                { key: 'CURRENCY', value: '貨幣' },
                { key: 'IB_ID', value: '代理賬號' },
                // { key: 'IB_NAME', value: '代理姓名' },
                { key: 'OID', value: '辦事處號碼' },
                { key: 'OFFICE_NAME', value: '所屬辦事處' },
                { key: 'RID', value: '地區編號' },
                { key: 'ACC_NAME', value: '所屬地區' },
                { key: 'cmd', value: '交易類型' },
                { key: 'VOLUME', value: '手數' },
                { key: 'SYMBOL', value: '產品' },
                { key: 'security', value: '產品類型' },
                { key: 'SYMBOL_CONTRACT_SIZE', value: '合約大小' },
                { key: 'OPEN_TIME', value: '開倉時間' },
                { key: 'OPEN_PRICE', value: '開倉價' },
                { key: 'CLOSE_TIME', value: '平倉時間' },
                { key: 'CLOSE_PRICE', value: '平倉價' },
                { key: 'OPEN_VALUE', value: '開倉價值' },
                { key: 'CLOSE_VALUE', value: '平倉價值' },
                { key: 'TOTAL_VALUE', value: '交易單總價值' },
                { key: 'COMMISSION', value: '佣金' },
                { key: 'TAXES', value: '稅金' },
                { key: 'COMMISSION_AGENT', value: '代理佣金' },
                { key: 'SWAPS', value: '利息' },
                { key: 'PROFIT', value: '盈虧' },
                { key: 'PIPES', value: '價位差' },
                { key: 'COMMENT', value: '注釋' }
            ]
        }
    },
    en: {
        closedTradesReport: {
            posText: 'Type：',
            timeText: 'Open Time：',
            ticketText: 'Ticket：',
            groupText: 'Group：',
            symbolText: 'Symbol：',
            loginText: 'Login：',
            ibNumText: 'IB Account：',
            regionText: 'Region ID：',
            securityText: 'Security：',
            currencyText: 'Currency：',
            startTime: 'Start Time',
            endTime: 'End Time',
            downloadName: 'Closed Trades Report',
            openTime: 'Open Time',
            closedTime: 'Closed Time',
            cmdMapping: { 0: 'Buy', 1: 'Sell' },
            securityMapping: { 0: 'Forex', 1: 'CFD' },
            typeMapping: { "0": "Open", "1": "Closed" },
            loadText: 'Downloading now,please wait a moment...',
            tableHead: [
                { key: 'TICKET', value: 'Ticket' },
                { key: 'LOGIN', value: 'Login' },
                { key: 'NAME', value: 'Name' },
                { key: 'GROUP', value: 'Group' },
                { key: 'CURRENCY', value: 'Currency' },
                { key: 'IB_ID', value: 'IB Account' },
                // { key: 'IB_NAME', value: 'IB Name' },
                { key: 'OID', value: 'Office ID' },
                { key: 'OFFICE_NAME', value: 'Office Name' },
                { key: 'RID', value: 'Region ID' },
                { key: 'ACC_NAME', value: 'Region Name' },
                { key: 'cmd', value: 'Cmd' },
                { key: 'VOLUME', value: 'Volume' },
                { key: 'SYMBOL', value: 'Symbol' },
                { key: 'security', value: 'Security' },
                { key: 'SYMBOL_CONTRACT_SIZE', value: 'Contract Size' },
                { key: 'OPEN_TIME', value: 'Open Time' },
                { key: 'OPEN_PRICE', value: 'Open Price' },
                { key: 'CLOSE_TIME', value: 'Close Time' },
                { key: 'CLOSE_PRICE', value: 'Close Price' },
                { key: 'OPEN_VALUE', value: 'Open Value' },
                { key: 'CLOSE_VALUE', value: 'Close Value' },
                { key: 'TOTAL_VALUE', value: 'Total Value' },
                { key: 'COMMISSION', value: 'Commission' },
                { key: 'TAXES', value: 'Taxes' },
                { key: 'COMMISSION_AGENT', value: 'Commission Agent' },
                { key: 'SWAPS', value: 'Swaps' },
                { key: 'PROFIT', value: 'Profit' },
                { key: 'PIPES', value: 'Pipes' },
                { key: 'COMMENT', value: 'Comment' }
            ]
        }
    }
}


// WEBPACK FOOTER //
// ./src/language/manager-report/closedTradesReport.js